import { Box, Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import styles from '../style.module.scss';

const ScreenComponent = () => {
  return (
    <Container maxWidth="lg" className="mt-5">
      <div className={styles.InfoDiv}>
        <Grid container spacing={2} id="features">
          <Grid item md={5} xl={5} lg={7} sm={12} xs={12}>
            <h2 className={styles.secondaryText}>
              {' '}
              Boost your offline business reach
              <span className="text-muted">
                {' '}
                with tools that helps you in logisitics, analytics and catalogue needs.
              </span>
            </h2>
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems="center" direction="row" className="pt-3">
          <Box clone order={{ xs: 2, sm: 2, md: 1, lg: 1 }}>
            <Grid item md={6} xl={6} lg={6} sm={12} xs={12}>
              <h4 className={styles.screenText}>Catalogue Management</h4>
              <p className={`${styles.childText} pt-3`}>
                Now manage your catalogue hassle free, Eliminate all manual workbooks and other
                materials used to track/book keep your catalogue needs. Let’s digitise your
                catalogue.
              </p>
              <Nav.Link href="#startSelling" className="p-0">
                <h6 className={`${styles.linkText} d-flex align-items-center`}>
                  Request demo
                  <div className={`${styles.icon1Container} ml-2`}>
                    <img
                      alt="arzooo-header-logo"
                      className={styles.headerLogo}
                      src="/images/arrow1.svg"
                    ></img>
                  </div>
                </h6>
              </Nav.Link>
            </Grid>
          </Box>
          <Box clone order={{ xs: 1, sm: 1, md: 2, lg: 2 }}>
            <Grid
              item
              md={6}
              lg={6}
              xl={6}
              sm={12}
              xs={12}
              className="d-flex"
              justifyContent="center"
            >
              <div className={styles.screenContainer}>
                <img
                  alt="arzooo-header-logo"
                  className={styles.headerLogo}
                  src="/images/catalogue.svg"
                ></img>
              </div>
            </Grid>
          </Box>
        </Grid>
        <Grid container spacing={2} alignItems="center" direction="row" className="pt-3">
          <Box clone order={{ xs: 1, sm: 1, md: 1, lg: 1 }}>
            <Grid
              item
              md={6}
              lg={6}
              xl={6}
              sm={12}
              xs={12}
              className="d-flex"
              justifyContent="start"
            >
              <div className={styles.screenContainer}>
                <img
                  alt="arzooo-header-logo"
                  className={styles.headerLogo}
                  src="/images/order.svg"
                ></img>
              </div>
            </Grid>
          </Box>
          <Box clone order={{ xs: 2, sm: 2, md: 2, lg: 2 }}>
            <Grid item md={6} xl={6} lg={6} sm={12} xs={12}>
              <h4 className={styles.screenText}>Order Management</h4>
              <p className={`${styles.childText} pt-3`}>
                Now manage your catalogue hassle free, Eliminate all manual workbooks and other
                materials used to track/book keep your catalogue needs. Let’s digitise your
                catalogue.
              </p>
              <Nav.Link href="#startSelling" className="p-0">
                <h6 className={`${styles.linkText} d-flex align-items-center`}>
                  Request demo
                  <div className={`${styles.icon1Container} ml-2`}>
                    <img
                      alt="arzooo-header-logo"
                      className={styles.headerLogo}
                      src="/images/arrow1.svg"
                    ></img>
                  </div>
                </h6>
              </Nav.Link>
            </Grid>
          </Box>
        </Grid>
        <Grid container spacing={2} alignItems="center" direction="row" className="pt-3">
          <Box clone order={{ xs: 2, sm: 2, md: 1, lg: 1 }}>
            <Grid item md={6} xl={6} lg={6} sm={12} xs={12}>
              <h4 className={styles.screenText}>Revenue Growth Analysis</h4>
              <p className={`${styles.childText} pt-3`}>
                Now manage your catalogue hassle free, Eliminate all manual workbooks and other
                materials used to track/book keep your catalogue needs. Let’s digitise your
                catalogue.
              </p>
              <Nav.Link href="#startSelling" className="p-0">
                <h6 className={`${styles.linkText} d-flex align-items-center`}>
                  Request demo
                  <div className={`${styles.icon1Container} ml-2`}>
                    <img
                      alt="arzooo-header-logo"
                      className={styles.headerLogo}
                      src="/images/arrow1.svg"
                    ></img>
                  </div>
                </h6>
              </Nav.Link>
            </Grid>
          </Box>
          <Box clone order={{ xs: 1, sm: 1, md: 2, lg: 2 }}>
            <Grid
              item
              md={6}
              lg={6}
              xl={6}
              sm={12}
              xs={12}
              className="d-flex"
              justifyContent="center"
            >
              <div className={styles.screenContainer}>
                <img
                  alt="arzooo-header-logo"
                  className={styles.headerLogo}
                  src="/images/revenue.svg"
                ></img>
              </div>
            </Grid>
          </Box>
        </Grid>
      </div>
    </Container>
  );
};
export default ScreenComponent;
